module.exports = __webpack_public_path__ + "img/selbsterfahrung_240.0576a29d.webp";